import { createStore, compose } from 'redux';
import reducer from '../reducers';

// provide composeEnhancers for the redux devtools extension
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default (initialState) => {
    const store = createStore(
        reducer,
        initialState,
        composeEnhancers()

        // composeEnhancers(
        //     // use Redux Thunk middleware to be able to create async Redux actions
        //     applyMiddleware(thunk)
        // )
    );

    return store;
};